import illustrationUrl from '@/assets/illustrations/mobile-coming-soon/illustration.svg';
import { Button } from '@/components/primitives/Button';
import { useTranslation } from '@/hooks/useTranslation';
import { LegalLinks } from '@/modules/auth/components/LegalLinks';

const WEBSITE_URL = 'https://nabat.ai';
const CONTACT_URL = 'mailto:support@nabat.ai';
// The design's buttons are 44px tall, between the m and l scales.
const BUTTON_CLASS = 'h-11 font-button';

const TITLE = 'The mobile version is coming soon!';
const SUBTITLE = 'Wow! The right place, but a little too early.';
const DESCRIPTION =
  'We are working hard to deliver the best mobile GIS experience. In the meantime, you can enjoy NabatOS on any desktop.';

/** Shown instead of the app on phones and tablets, until there's a mobile version. */
export function MobileLandingPage() {
  const { t } = useTranslation();

  return (
    // The body doesn't scroll (the app is a full-screen map), so the page scrolls itself —
    // needed when the card is taller than the screen, e.g. a phone in landscape.
    <main className="flex h-dvh flex-col overflow-y-auto bg-surface-highlight">
      <div className="flex flex-1 items-center justify-center px-xxl py-xxxl">
        <div className="flex w-full max-w-[374px] flex-col gap-xxl rounded-[20px] border-[0.6px] border-solid border-[rgba(0,0,0,0.06)] bg-surface-highlight px-xxl pb-lg pt-xxxl">
          <div className="flex flex-col items-center gap-xxl">
            <img src={illustrationUrl} alt="" aria-hidden width={122} height={102} />
            <h1 className="w-full font-title text-size-4 font-semibold leading-10 text-foreground">
              {t(TITLE)}
            </h1>
          </div>

          <div className="flex flex-col gap-xxl">
            <div className="text-size-n1 leading-[22px] text-foreground">
              <p>{t(SUBTITLE)}</p>
              <p>{t(DESCRIPTION)}</p>
            </div>

            <div className="flex flex-col gap-sm">
              <Button
                asChild
                appearance="solid"
                kind="inverse"
                scale="l"
                width="full"
                className={BUTTON_CLASS}
              >
                <a href={WEBSITE_URL}>{t('Back to nabat.ai')}</a>
              </Button>
              <Button
                asChild
                appearance="outline"
                kind="neutral"
                scale="l"
                width="full"
                className={BUTTON_CLASS}
              >
                <a href={CONTACT_URL}>{t('Contact us')}</a>
              </Button>
            </div>
          </div>
        </div>
      </div>

      <footer className="pb-[34px] pt-lg">
        <LegalLinks className="justify-center text-foreground" />
      </footer>
    </main>
  );
}
